import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_MOCK_IDP = registerFeatureWithDescription({
    numericalId: 2502,
    id: "mock-idp",
    name: "Mock IdP (Fentra)",
    internalUseOnly: true,
    descriptionLines: [
        "Enables the embedded Fentra mock Identity Provider. Requires system-admin access. For QA testing of SCIM provisioning and SAML SSO flows.",
    ],
})
